import "./stepper.scss";

// Reusable V2 step indicator: equal segments, RTL (step 1 is the rightmost), filled up to `current`.
function Stepper({ steps, current }) {
  return (
    <div className="v2-stepper">
      {Array.from({ length: steps }, (_, i) => (
        <span key={i} className={`v2-stepper-segment${i + 1 <= current ? " v2-stepper-segment--filled" : ""}`} />
      ))}
    </div>
  );
}

export default Stepper;
